var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgRemoteLogin = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 87 87"
}, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
  fillRule: "evenodd",
  clipRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  stroke: "#1984EC",
  strokeWidth: 3,
  d: "M44.758 85C66.42 85 85 66.42 85 44.758 85 20.58 66.42 2 44.758 2 20.58 2 2 20.58 2 44.758 2 66.42 20.58 85 44.758 85Z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#1984EC",
  d: "M44 23c6.629 0 12 5.316 12 11.875 0 3.994-2 7.519-5.053 9.67v.955c0 .69-.565 1.25-1.263 1.25H48.42v2.5l-1.622.8a.72.72 0 0 0-.19 1.158L48.422 53l-1.222.603a.73.73 0 0 0-.403.647c0 .275.156.523.403.647l1.222.603v1.25l-1.224.583a.72.72 0 0 0-.412.637.73.73 0 0 0 .392.652l1.27.66L44.63 63l-5.051-2.5V46.75h-1.263c-.698 0-1.264-.56-1.264-1.25v-.955C34 42.394 32 38.87 32 34.875 32 28.315 37.371 23 44 23m4.42 9.375C48.42 29.96 46.44 28 44 28s-4.421 1.96-4.421 4.375 1.98 4.375 4.42 4.375 4.421-1.96 4.421-4.375"
}))));
export { SvgRemoteLogin as ReactComponent };
export default __webpack_public_path__ + "static/media/remoteLogin.8974da3a.svg";